import moment from "moment";
import { DEFAULT_EVENT_COLOR } from "./CalendarConstants";

export const HOLIDAYS = [
  { date: "2025-12-25", name: "1. Weihnachtstag" },
  { date: "2025-12-26", name: "2. Weihnachtstag" },
  { date: "2026-01-01", name: "Neujahr" },
];

export const school_holidays = [
  { title: 'Weihnachtsferien', start: moment("2025-12-22").toDate(), end: moment("2026-01-06").toDate() },
];

export const toLocalISO = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const getRangeISO = (date, view) => {
  const m = moment(date);
  let start, end;

  if (view === "day") {
    // .clone() ensures 'start' stays at the beginning 
    // while 'm' (or 'end') moves to the end.
    start = m.clone().startOf("day");
    end = m.clone().endOf("day");
  } else if (view === "week") {
    start = m.clone().startOf("isoWeek");
    end = m.clone().endOf("isoWeek");
  } else if (view === "agenda") {
    start = m.clone().startOf("day");
    end = m.clone().add(30, "days").endOf("day");
  } else {
    // month — expand to cover visible grid (adjacent month days)
    start = m.clone().startOf("month").startOf("isoWeek");
    end = m.clone().endOf("month").endOf("isoWeek");
  }

  return {
    start: start.toISOString(),
    end: end.toISOString()
  };
};

// --- EVENT HELPERS ---

export const isAllDay = (event) => {
  const s = moment(event.start);
  const e = moment(event.end);
  return s.hours() === 0 && s.minutes() === 0 && e.hours() === 23 && e.minutes() === 59;
};

export const isMultiDay = (event) => {
  return !moment(event.start).isSame(moment(event.end), 'day');
};

export const durationMinutes = (event) => {
  return moment(event.end).diff(moment(event.start), 'minutes');
};

export const dateKey = (date) => moment(date).format('YYYY-MM-DD');

export const spanDays = (event) => {
  const s = moment(event.start).startOf('day');
  const e = moment(event.end).startOf('day');
  return e.diff(s, 'days') + 1;
};

export const getEventColor = (event) => {
  if (event.externalConfigId) {
    const theme = getExternalCalendarColor(event.externalConfigId);
    if (theme) return theme.border;
  }
  if (event.color) return event.color;
  return DEFAULT_EVENT_COLOR;
};

// --- EXTERNAL CALENDAR COLORS ---

const EXTERNAL_PALETTE = [
  { bg: "#f0f9ff", border: "#0ea5e9", icon: "#0284c7", text: "#0c4a6e" }, // Sky
  { bg: "#fdf4ff", border: "#d946ef", icon: "#c026d3", text: "#701a75" }, // Fuchsia
  { bg: "#fff1f2", border: "#f43f5e", icon: "#e11d48", text: "#881337" }, // Rose
  { bg: "#ecfdf5", border: "#10b981", icon: "#059669", text: "#064e3b" }, // Emerald
  { bg: "#fff7ed", border: "#f97316", icon: "#ea580c", text: "#7c2d12" }, // Orange
  { bg: "#f5f3ff", border: "#8b5cf6", icon: "#7c3aed", text: "#4c1d95" }, // Violet
  { bg: "#ecfeff", border: "#06b6d4", icon: "#0891b2", text: "#164e63" }, // Cyan
  { bg: "#fffff0", border: "#eab308", icon: "#ca8a04", text: "#713f12" }, // Yellow
];

export const getExternalCalendarColor = (configId) => {
  if (!configId) return null;
  // Simple hash to pick a color deterministically
  // configId is likely a UUID or int string
  let hash = 0;
  const str = String(configId);
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % EXTERNAL_PALETTE.length;
  return EXTERNAL_PALETTE[index];
};